import './App.css';
import Header from './conponents/Header/Header';
import PigeonShop from './conponents/PigeonShop/PigeonShop';
function App() {
  return (
    <div className="App">
      <Header></Header>
      <PigeonShop></PigeonShop>

    </div>
  );
}

export default App;
